export enum Steps {
  GoPaperless = 'GoPaperless',
  ChangeEmail = 'ChangeEmailModal',
  Success = 'Success',
}
